<rt-dropdown (click)="$event.preventDefault()">
  <ng-template [ngTemplateOutlet]="selectHeaderTemplate || headerTemplate"> </ng-template>

  <div *ngIf="hasSearch" class="header">
    <rt-form-field>
      <rt-input
        #input
        (keydown.esc)="keydownEscape($event)"
        [disableInvalidStyles]="true"
        [autoFocus]="true"
        [formControl]="control"
        [placeholder]="text && text.placeholder"
        [hasClearButton]="true"
        [loading]="loading"
        (reset)="control.reset()"
        variant="rounded"
      >
        <rt-icon prefix [name]="'search'"> </rt-icon>
      </rt-input>
    </rt-form-field>
  </div>

  <rt-attributes-select-list
    *ngIf="suggestions.rows.length > 0"
    [maxHeight]="maxDropdownHeight"
    [suggestionsListData]="suggestions"
    [createNewItemId]="CREATE_NEW_ITEM_ID"
    [createNewAttr]="createNewAttr"
    [highlightedId]="state.highlighted && state.highlighted.id"
    (saveAttribute)="onSaveAttribute($event, 'suggestion')"
    (loadMore)="onLoadMore()"
  >
  </rt-attributes-select-list>

  <rt-dropdown-item *ngIf="state.errors && state.errors.maxlength">
    {{ maxLengthExceeded }}
  </rt-dropdown-item>

  <ng-container *ngIf="!showAlreadyExists && control.valid">
    <rt-dropdown-item
      *ngIf="suggestions.rows.length === 0 && state.preventCreateMessageVisible && !createDisabled"
    >
      <ng-container
        *ngTemplateOutlet="emptyResultsWithNoAbilityToCreateNewWithValue"
      ></ng-container>
    </rt-dropdown-item>

    <rt-dropdown-item
      *ngIf="suggestions.rows.length === 0 && state.preventCreateMessageVisible && createDisabled"
    >
      <ng-container *ngTemplateOutlet="emptyResultsWithCreatingDisabled"></ng-container>
    </rt-dropdown-item>

    <rt-dropdown-item
      *ngIf="suggestions.rows.length > 0 && state.preventCreateMessageVisible && !createDisabled"
    >
      <ng-container *ngTemplateOutlet="nonEmptyResultsWithNoAbilityToCreateNew"></ng-container>
    </rt-dropdown-item>

    <rt-dropdown-item
      *ngIf="!state.preventCreateMessageVisible && suggestions.rows.length === 0 && !canCreate"
    >
      <ng-container *ngTemplateOutlet="emptyResultsWithNoAbilityToCreateNew"></ng-container>
    </rt-dropdown-item>

    <rt-dropdown-item
      *ngIf="suggestions.rows.length === 0 && canCreate"
      (click)="onSaveAttribute({ value: control.value }, 'input')"
    >
      <ng-container *ngTemplateOutlet="createNewAttr"></ng-container>
    </rt-dropdown-item>
  </ng-container>

  <rt-dropdown-item *ngIf="showAlreadyExists">
    <ng-container *ngTemplateOutlet="attrAlreadyExists"></ng-container>
  </rt-dropdown-item>

  <ng-template [ngIf]="selectFooterTemplate" [ngTemplateOutlet]="selectFooterTemplate">
  </ng-template>
</rt-dropdown>

<ng-template #maxLengthExceeded>
  <div class="special-item with-padding">
    <div class="head">{{ text.maxLengthExceeded }}</div>
  </div>
</ng-template>

<ng-template #nonEmptyResultsWithNoAbilityToCreateNew>
  <div class="special-item with-padding">
    <div class="head">"{{ control.value }}" {{ text.notFound }}</div>
    <div class="value">{{ text.noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNewWithValue>
  <div class="special-item">
    <div class="head">{{ text.noAbilityToCreateAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithNoAbilityToCreateNew>
  <div class="special-item with-padding">
    <div class="head">{{ text.emptyResults }}</div>
    <div class="value">{{ text.noAbilityToCreateAttr }}</div>
  </div>
</ng-template>

<ng-template #emptyResultsWithCreatingDisabled>
  <div class="special-item with-padding">
    <div class="head">{{ text.emptyResults }}</div>
  </div>
</ng-template>

<ng-template #attrAlreadyExists>
  <div class="special-item">
    <div class="head">{{ text.attrAlreadyExists }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>

<ng-template #createNewAttr>
  <div class="special-item clickable">
    <div class="head">{{ text.createNewAttr }}</div>
    <div class="value">{{ control.value }}</div>
  </div>
</ng-template>
<ng-template #headerTemplate>
  <rt-dropdown-header [fullWidthTitle]="true">
    {{ text?.placeholder }}
  </rt-dropdown-header>
</ng-template>
